/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import loadable from '@loadable/component'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

// Components
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils'
import {routes as _routes} from '@salesforce/retail-react-app/app/routes'

// Import Adyen CSS styles
import '@adyen/adyen-salesforce-pwa/dist/app/adyen.css'

const fallback = <Skeleton height="75vh" width="100%" />

// Create your pages here and add them to the routes array
// Use loadable to split code into smaller js chunks
const Home = loadable(() => import('./pages/home'), {fallback})
const MyNewRoute = loadable(() => import('./pages/my-new-route'))
const Checkout = loadable(() => import('./pages/checkout'))
const CheckoutConfirmation = loadable(() => import('./pages/checkout/confirmation'))
const ProductDetail = loadable(() => import('./pages/product-detail'), {fallback})
const AdyenCheckoutRedirect = loadable(() => import('./pages/checkout/redirect'), {
    fallback
})
const AdyenCheckoutError = loadable(() => import('./pages/checkout/error'), {
    fallback
})

const CheckoutReview = loadable(() => import('./pages/checkout/review'), {
    fallback: fallback
})

const routes = [
    {
        path: '/',
        component: Home,
        exact: true
    },
    {
        path: '/checkout',
        component: Checkout,
        exact: true
    },
    {
        path: '/information',
        component: Checkout,
        exact: true
    },
    {
        path: '/shipping',
        component: Checkout,
        exact: true
    },
    {
        path: '/checkout/redirect',
        component: AdyenCheckoutRedirect
    },
    {
        path: '/shipping/redirect',
        component: AdyenCheckoutRedirect
    },
    {
        path: '/information/redirect',
        component: AdyenCheckoutRedirect
    },
    {
        path: '/checkout/error',
        component: AdyenCheckoutError
    },
    {
        path: '/my-new-route',
        component: MyNewRoute
    },
    {
        path: '/product/:productId',
        component: ProductDetail
    },
    {
        path: '/shipping/error',
        component: AdyenCheckoutError
    },
    {
        path: '/information/error',
        component: AdyenCheckoutError
    },
    {
        path: '/checkout/confirmation/:orderNo',
        component: CheckoutConfirmation
    },
    {
        path: '/shipping/confirmation/:orderNo',
        component: CheckoutConfirmation
    },
    {
        path: '/information/confirmation/:orderNo',
        component: CheckoutConfirmation
    },
    {
        path: '/checkout/review',
        component: CheckoutReview,
        exact: true
    },
    {
        path: '/my-new-route',
        component: MyNewRoute
    },
    ..._routes
]

export default () => {
    const config = getConfig()
    return configureRoutes(routes, config, {
        ignoredRoutes: ['/callback', '*']
    })
}
